/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { PagedRejectionFullModel } from '../model/paged-rejection-full-model';
// @ts-ignore
import { RejectionFullModel } from '../model/rejection-full-model';
// @ts-ignore
import { SaveRejectionRequest } from '../model/save-rejection-request';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class RejectionResourceService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Create Rejection
     * @param saveRejectionRequest 
     * @param component Vanilla component (e.g. manager, cc, profile, cashbox)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createRejection(saveRejectionRequest: SaveRejectionRequest, component?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<RejectionFullModel>;
    public createRejection(saveRejectionRequest: SaveRejectionRequest, component?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RejectionFullModel>>;
    public createRejection(saveRejectionRequest: SaveRejectionRequest, component?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RejectionFullModel>>;
    public createRejection(saveRejectionRequest: SaveRejectionRequest, component?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (saveRejectionRequest === null || saveRejectionRequest === undefined) {
            throw new Error('Required parameter saveRejectionRequest was null or undefined when calling createRejection.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (component !== undefined && component !== null) {
            localVarHeaders = localVarHeaders.set('component', String(component));
        }

        // authentication (apiKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKey', 'X-API-Key', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vn/rejections`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<RejectionFullModel>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: saveRejectionRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get Rejections
     * @param cityId 
     * @param date 
     * @param decorExists 
     * @param deliveryExists 
     * @param limit 
     * @param page 
     * @param pickupExists 
     * @param productInfoIds 
     * @param promoExists 
     * @param query 
     * @param storeId 
     * @param component Vanilla component (e.g. manager, cc, profile, cashbox)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRejections(cityId?: number, date?: string, decorExists?: boolean, deliveryExists?: boolean, limit?: number, page?: number, pickupExists?: boolean, productInfoIds?: Array<number>, promoExists?: boolean, query?: string, storeId?: number, component?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedRejectionFullModel>;
    public getRejections(cityId?: number, date?: string, decorExists?: boolean, deliveryExists?: boolean, limit?: number, page?: number, pickupExists?: boolean, productInfoIds?: Array<number>, promoExists?: boolean, query?: string, storeId?: number, component?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedRejectionFullModel>>;
    public getRejections(cityId?: number, date?: string, decorExists?: boolean, deliveryExists?: boolean, limit?: number, page?: number, pickupExists?: boolean, productInfoIds?: Array<number>, promoExists?: boolean, query?: string, storeId?: number, component?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedRejectionFullModel>>;
    public getRejections(cityId?: number, date?: string, decorExists?: boolean, deliveryExists?: boolean, limit?: number, page?: number, pickupExists?: boolean, productInfoIds?: Array<number>, promoExists?: boolean, query?: string, storeId?: number, component?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cityId, 'city_id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>date, 'date');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>decorExists, 'decor_exists');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deliveryExists, 'delivery_exists');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>limit, 'limit');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>page, 'page');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pickupExists, 'pickup_exists');
        if (productInfoIds) {
            productInfoIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'product_info_ids');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>promoExists, 'promo_exists');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>query, 'query');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>storeId, 'store_id');

        let localVarHeaders = this.defaultHeaders;
        if (component !== undefined && component !== null) {
            localVarHeaders = localVarHeaders.set('component', String(component));
        }

        // authentication (apiKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKey', 'X-API-Key', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vn/rejections`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedRejectionFullModel>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update Rejection
     * @param id 
     * @param saveRejectionRequest 
     * @param component Vanilla component (e.g. manager, cc, profile, cashbox)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateRejection(id: number, saveRejectionRequest: SaveRejectionRequest, component?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<RejectionFullModel>;
    public updateRejection(id: number, saveRejectionRequest: SaveRejectionRequest, component?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RejectionFullModel>>;
    public updateRejection(id: number, saveRejectionRequest: SaveRejectionRequest, component?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RejectionFullModel>>;
    public updateRejection(id: number, saveRejectionRequest: SaveRejectionRequest, component?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateRejection.');
        }
        if (saveRejectionRequest === null || saveRejectionRequest === undefined) {
            throw new Error('Required parameter saveRejectionRequest was null or undefined when calling updateRejection.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (component !== undefined && component !== null) {
            localVarHeaders = localVarHeaders.set('component', String(component));
        }

        // authentication (apiKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKey', 'X-API-Key', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vn/rejections/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<RejectionFullModel>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: saveRejectionRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
